import React from "react";
import "./Header.css";
import {Link, useNavigate} from "react-router-dom";
import {Button} from "primereact/button";
import Menu from "./Menu";
import ProfileMenu from "./ProfileMenu";
import Search from "./Search";

const userEmptyIcon = "/icons/user-empty2.png";

const Header = (props) => {
    const {isAuthenticated, isInstructor, logout} = props;

    // const [isSearchActive, setIsSearchActive] = useState(false);

    const navigate = useNavigate();

    const isDesktop = () => {
        return window.innerWidth > 991;
    };

    return (
        <div className="header">
            {/*<div id="overlay" onClick={()=>setIsSearchActive(!isSearchActive)} style={{display: (isSearchActive ? "block" : "none")}}></div>*/}

            <Link to='/' className="left part">
                <img src="/assets/images/culogo_orjinal.svg" alt="logo" style={{height: "32px"}}></img>
            </Link>

            <Menu/>

            <div className="mid p-fluid" style={{zIndex: "1001"}}>
                <Search
                    // onClick={()=>setIsSearchActive(!isSearchActive)}
                />
            </div>

            {isAuthenticated ?
                <div className="right part">
                    {isInstructor && <Button label="Eğitmen" text onClick={() => navigate("/instructor/courses")} size="small"
                                             tooltip="Buradan eğitmen paneline geçiş yapın." tooltipOptions={{position: 'bottom', hideDelay: 250 }}/>}
                    <Button label="Öğrenim İçeriğim" text onClick={() => navigate("/user/myCourses")} size="small"/>
                    <ProfileMenu logout={logout}/>
                </div>
                :
                <div className="right part flex flex-group gap-3">
                    <Button onClick={() => navigate(`/login`)} label="Giriş" outlined size="small"/>
                    <Button onClick={() => navigate(`/signup`)} label="Kaydol" raised size="small"/>
                </div>}
        </div>
    );
}
export default Header;
